/**
 * The domains (curated, structured knowledge) an agent reads, for the Account Settings
 * Knowledge tab. Served by the Gateway (GET /channels/portal/domains), which returns only
 * agents the user may use (403 otherwise) and never a domain's files or body.
 */
import { gatewayClient } from '../../client/GatewayClient';
import type { LocalizedText } from './knowledgeBases';

export interface Domain {
  /** Domain name, e.g. "cmhk-sales"; also the last-resort display name. */
  name: string;
  displayName: LocalizedText;
  description: LocalizedText;
  /** "agent": mapped to specific agents; "shared": visible to every agent. */
  scope: 'agent' | 'shared';
  version: string | null;
  publishedAt: string | null;
}

export async function listDomains(agent: string): Promise<Domain[]> {
  const resp = await gatewayClient.get<{ items?: Domain[] }>('/channels/portal/domains', { agent });
  return resp.items ?? [];
}
